import { Button } from "@/components/ui/button";
import ihmLogo from "@/assets/ihm-logo.jpg";
import ihmBusinessSchoolLogo from "@/assets/ihm-business-school-logo.png";
const AIForLeaders = () => {
  return <section className="py-20 px-6 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content - LEFT side (reversed from AI-Lyftet) */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground">
              AI for leaders
            </h2>
            
            <div className="text-muted-foreground text-lg leading-relaxed">
              <p>
                Do you want to understand how AI transforms work processes and leadership requirements? Secure your practical AI knowledge and broaden your understanding of AI technology with the course AI for Leaders. This course, developed by us at the AI-Labbet in collaboration with IHM Business School, meets the increasing demand for strategic competence and equips you with the skills to effectively lead your organization in today's quickly evolving technological landscape. Sign up now for a unique opportunity to integrate AI into your leadership, ensuring both efficiency and competitiveness.
              </p>
            </div>
            
            <a href="https://www.ihm.se/utbildningar/management/ai-for-ledare/" target="_blank" rel="noopener noreferrer">
              <Button variant="secondary" size="lg" className="mt-4">
                Read more →
              </Button>
            </a>
          </div>
          
          {/* Logo - RIGHT side */}
          <div className="flex items-center justify-center h-full">
            <img 
              src={ihmBusinessSchoolLogo} 
              alt="IHM Business School" 
              className="h-full w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>;
};
export default AIForLeaders;